import React, { useEffect, useState } from 'react';
import {
  Breakpoint,
  getBreakpoints,
  isBreakpointSmallOrBelow,
  useBreakpoint,
} from '@noths/polaris-client-ribbons-base';
import { Drawer, DrawerProps, Responsive } from '@noths/polaris-client-ribbons-design-system';
import dynamic from 'next/dynamic';

import { ModalLoader } from 'src/components/molecules/ModalLoader';
import { FilterListContainer } from '../containers/FilterListContainer';
import * as styles from '../styles/Filter.styles';

const FilterModal = dynamic(
  async () => (await import(/* webpackChunkName: "FilterModal" */ './FilterModal')).FilterModal,
  { loading: () => <ModalLoader /> },
);

export type FilterProps = {
  isModalOpen: boolean;
  closeFilterModal: () => void;
  onShowList: () => void;
};

export const Filter = ({ isModalOpen, closeFilterModal, onShowList }: FilterProps) => {
  const breakpoint = useBreakpoint();
  const breakpointsWithModal = getBreakpoints({ maxBreakpoint: Breakpoint.M });

  const isMobile = isBreakpointSmallOrBelow(breakpoint);
  const [drawerSize, setDrawerSize] = useState<DrawerProps['panelSize']>('partial');
  const [transitionFrom, setTransitionFrom] = useState<DrawerProps['transitionFrom']>('bottom');

  const handleModalClose = () => {
    closeFilterModal();
  };

  useEffect(() => {
    if (!breakpointsWithModal.includes(breakpoint)) {
      closeFilterModal();
    }

    setDrawerSize(isMobile ? 'full' : 'partial');
    setTransitionFrom(isMobile ? 'bottom' : 'left');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return (
    <div css={styles.filterWrapper}>
      <Responsive minBreakpoint={Breakpoint.L}>
        <FilterListContainer removeSortFilter />
      </Responsive>
      <Drawer
        isOpen={isModalOpen}
        onRequestClose={handleModalClose}
        onOverlayClick={handleModalClose}
        onAfterClose={onShowList}
        contentLabel="Product filtering options"
        useScopedStyles={true}
        contentContainerStyles={styles.drawerContentContainer}
        transitionFrom={transitionFrom}
        panelSize={drawerSize}
      >
        <FilterModal />
      </Drawer>
    </div>
  );
};
